import { render, staticRenderFns } from "./VStatuses.vue?vue&type=template&id=1d7991f5&"
import script from "./VStatuses.vue?vue&type=script&lang=js&"
export * from "./VStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports